
const getters = {
  colors: (state) => state.colors,
  tastes: (state) => state.tastes,
  odors: (state) => state.odors,
  states: (state) => state.states,
  symptoms: (state) => state.symptoms,
  selectedObservations: (state) => state.selectedObservations,
  observationsFilterIsActive: (state) => state.selectedObservations.length > 0,
  observationIsSelected: (state) =>
    (observation) => state.selectedObservations.includes(observation),
  loadingObservations: (state) => state.loading
}

export default getters
